// react components
import React, {
    useState,
} from 'react'

// data
import {
    contentTypeModelTypeSite,
    fieldTypeLayoutSite,
} from 'data'

// serializers
import {
    ContentTypeFieldTypes,
} from 'serializers/site'

// props
type TableHeaderColumn825Props = {
    column: string
    contentType: contentTypeModelTypeSite
    fieldOptions: ContentTypeFieldTypes | undefined
    filterValues: any
    inModal?: boolean
    setFilter?: (e: any, f?: any) => void
    title: string
}

// main
export const TableHeaderColumn825: React.FC<TableHeaderColumn825Props> = React.memo(({
    column,
    contentType,
    fieldOptions,
    filterValues,
    inModal,
    setFilter,
    title,
}) => {

    const [showActionPopover, setShowActionPopover] = useState(false)

    if (column === 'images_temp') return null  // TODO: dynamic
    if (contentType === 'staff_staffmessage' && column === 'get_image_lq') return null  // TODO: dynamic
    if (!fieldOptions) {
        return (
            <th className='th-column field-error'>
                <div className='th-div'>Error</div>
            </th>
        )
    }

    return (
        <th className={`th-column field-${fieldTypeLayoutSite[fieldOptions.fieldType] || fieldOptions.fieldType}`}>
            <div className='th-div-wrap'>
                {setFilter && filterValues?.[contentType]?.[column] && (
                    <i
                        className='th-filter-button main-icon mo-new-icon-filter-circle-xmark-solid pointer'
                        onClick={() => {
                            setFilter({
                                value: undefined,
                                params: column
                            })
                        }}
                    />
                )}
                <div className='th-div'>{title}</div>
            </div>
        </th>
    )
})
